import apiClient from './client';

export interface WhatsappFollowupConfig {
  enabled: boolean;
  delayHours: number;
  templateName: string;
  templateLanguage: string;
  templateHasParams: boolean;
}

export interface WhatsappFollowupSettings {
  config: WhatsappFollowupConfig;
  infra: { schedule: string; lookbackHours: number };
}

export const globalsApi = {
  setupGlobalData: async () => {
    const response: any = await apiClient.post('/globals/setup');
    return response.data || response;
  },

  fetchStatistics: async () => {
    const response: any = await apiClient.get('/globals/statistics');
    return response.data || response;
  },

  fetchLocationsData: async () => {
    const response: any = await apiClient.get('/globals/locations');
    return response.data || response;
  },

  getIntroductionVideoUrl: async (): Promise<string> => {
    const response: any = await apiClient.get('/globals/intro-video');
    return response.data || response;
  },

  setIntroductionVideoUrl: async (args: { url: string }) => {
    const response: any = await apiClient.put('/globals/intro-video', args);
    return response.data || response;
  },

  getAgentsTelegramChannelUrl: async (): Promise<string> => {
    const response: any = await apiClient.get('/globals/agents-telegram-channel');
    return response.data || response;
  },

  setAgentsTelegramChannelUrl: async (args: { url: string }) => {
    const response: any = await apiClient.put('/globals/agents-telegram-channel', args);
    return response.data || response;
  },

  getTermsAndConditions: async (): Promise<string> => {
    const response: any = await apiClient.get('/globals/terms');
    return response.data || response;
  },

  setTermsAndConditions: async (args: { termsAndConditions: {[key: string]: string} }) => {
    const response: any = await apiClient.put('/globals/terms', args);
    return response.data || response;
  },

  getSavTermsAndConditions: async (): Promise<string> => {
    const response: any = await apiClient.get('/globals/terms-sav');
    return response.data || response;
  },

  setSavTermsAndConditions: async (args: { termsAndConditions: {[key: string]: string} }) => {
    const response: any = await apiClient.put('/globals/terms-sav', args);
    return response.data || response;
  },

  getWhatsappFollowupConfig: async (): Promise<WhatsappFollowupSettings> => {
    const response: any = await apiClient.get('/globals/whatsapp-followup');
    return response.data || response;
  },

  setWhatsappFollowupConfig: async (args: Partial<WhatsappFollowupConfig>): Promise<{ config: WhatsappFollowupConfig }> => {
    const response: any = await apiClient.put('/globals/whatsapp-followup', args);
    return response.data || response;
  },
};
